/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IButtonStyles } from '@fluentui/react/lib/Button';
import { IStackStyles } from '@fluentui/react/lib/Stack';
import { ITheme } from '@fluentui/react/lib/Styling';
import { CSSProperties } from 'react';
import { CoreColors } from '../../../styles/teams';
import { MOBILE_FONT_SIZE } from '../../../utilities/FontUtils';

export const stackStyles: IStackStyles = { root: { margin: '0 20px 0 20px' } };
export const addRecipientsButtonStyles: IButtonStyles = { root: { width: 'calc(100% - 40px)', margin: '20px' } };

export const removeButtonStyles: IButtonStyles = {
    root: {
        color: CoreColors.appRed,
    },
};

export const h3Style = (theme: ITheme): CSSProperties => ({ color: theme.palette.black });

export const recipientListInputStackStyles = (theme: ITheme): IStackStyles => {
    return { root: { fontSize: MOBILE_FONT_SIZE, color: theme.palette.black } };
};
